export default __webpack_public_path__ + "static/video-frame-bf74dcf27a5ca243b0ad4e3d3712f785.png";